module.exports = __webpack_public_path__ + "static/media/icon-download-file.09b574ff.svg";